import type {ImmersivePlugin} from '../plugin/copilot-immersive-plugin'

export function getActivePluginFromLocation(
  location: {pathname: string},
  plugins: ImmersivePlugin[],
): ImmersivePlugin | undefined {
  const {pathname} = location
  if (!pathname) return
  return plugins.find(p => p.matchPage?.(pathname) || p.matchView?.(pathname))
}
